import './search-result-item-card.scss'

import Component from "vue-class-component";
import { PropType } from "vue";
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import { SearchResult } from "@skinsoft/types";
import { searchResultSelectors } from "@skinsoft/search-data-store";
import { itemTypeFormatters } from "@skinsoft/entity/src/item";

import { ReactiveVue } from "@skinsoft/reactive-vue";
import { Touchable } from "../touchable";
import { Media } from "../item-card/media";
import { Description } from "../item-card/description";
import { Location } from '../item-card/location'

@Component({
    components: {
        sTouchable: Touchable,
        sMedia: Media,
        sDescription: Description,
        sLocation: Location,
    },
    props: {
        focused: {
            required: false,
        },
        item: {
            type: Object as PropType<SearchResult>,
            required: true,
        },
        readonly: {
            default: false,
            required: false,
        },
        displayType: {
            required: false
        }
    },
    template: require('./search-result-item-card.html')
})
export class SearchResultItemCard extends ReactiveVue {
    public item: SearchResult
    public interactive: boolean
    public focused: boolean
    public readonly: boolean

    public contentReady: boolean = false;
    public encounteredError: boolean = false;
    public validated: boolean = false;
    public loadingIcon = faCircleNotch;

    public searchResultSelectors = searchResultSelectors

    private descriptionReady: boolean = false;
    private locationReady: boolean = false;

    public onDescriptionReady() {
        this.descriptionReady = true;
        this.processContentReady();
    }

    public onLocationReady() {
        this.locationReady = true;
        this.processContentReady();
    }

    public processContentReady() {
        this.contentReady = this.descriptionReady && this.locationReady;
    }

    private get readableCardType() {
        return this.$t(itemTypeFormatters.getReadableType(searchResultSelectors.itemType(this.item) ?? ''))
    }
}